<form class="form" [formGroup]="targetForm">
  <ng-container *ngIf="isCustomTarget">
    <h2>Do you want to offset this target?</h2>
    <div class="form-row">
      <mat-slide-toggle formControlName="turn_offset_type">Yes</mat-slide-toggle>
    </div>
    <ng-container *ngIf="targetForm.get('turn_offset_type').value">
      <h2>Do you want to add or substract to the target?</h2>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Offset Type</mat-label>
          <mat-select formControlName="offset_type">
            <mat-option *ngFor="let type of types" [value]="type.value">
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Offset Amount</mat-label>
          <input placeholder="Offset amount" matInput formControlName="offset_amount" />
        </mat-form-field>
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!isCustomTarget">
    <h2>Please select the target</h2>
    <div class="form-row">
      <mat-form-field>
        <mat-label>Target Amount</mat-label>
        <input placeholder="Target amount" matInput formControlName="offset_amount" required />
      </mat-form-field>
    </div>
  </ng-container>
  <h2>Now are you concerned if a reading is higher or lower than that target?</h2>
  <div class="form-row">
    <mat-form-field>
      <mat-label>Please select one option</mat-label>
      <mat-select formControlName="operator" required>
        <mat-option *ngFor="let operator of operators" [value]="operator.value">
          {{ operator.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
